import React from 'react';
import { ProductCardSpecItem, ProductCardSpecItemProps } from '../../atoms/ProductCardSpecItem';
import { ProgressBar } from '../../atoms/ProgressBar';
import { FontAwesomeIcon } from '../../types/fontAwesomeIcons';

type ProgressBarSpec = {
  progressBar: true;
  progressBarValue: number;
  progressBarLeftSpec: Extract<
    ProductCardSpecItemProps,
    { icon: typeof FontAwesomeIcon.RocketLaunch | typeof FontAwesomeIcon.Users }
  >;
  progressBarRightSpec: Extract<ProductCardSpecItemProps, { icon: typeof FontAwesomeIcon.Clock }>;
};

type SingleSpec = {
  progressBar?: false;
  spec: Extract<
    ProductCardSpecItemProps,
    {
      icon:
        | typeof FontAwesomeIcon.Calendar
        | typeof FontAwesomeIcon.FaceFrown
        | typeof FontAwesomeIcon.Check
        | typeof FontAwesomeIcon.Ticket
        | typeof FontAwesomeIcon.CircleExclamation;
    }
  >;
};

export type ProductCardSpecsProps = ProgressBarSpec | SingleSpec;

export const ProductCardSpecs: React.FC<ProductCardSpecsProps> = (props: ProductCardSpecsProps) => {
  const { progressBar } = props;

  if (progressBar) {
    const { progressBarValue, progressBarLeftSpec, progressBarRightSpec } = props;
    return (
      <div className="flex min-h-14 flex-col gap-1 sm:min-h-0">
        <ProgressBar value={progressBarValue} />
        <div className="flex flex-col gap-1 sm:flex-row sm:justify-between">
          <ProductCardSpecItem {...progressBarLeftSpec} />
          <ProductCardSpecItem {...progressBarRightSpec} />
        </div>
      </div>
    );
  }

  const { spec } = props;
  return (
    <div className="min-h-14 before:block before:h-3 before:content-[''] sm:min-h-0">
      <ProductCardSpecItem {...spec} />
    </div>
  );
};
